var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.budget
      ? _c("div", { staticClass: "containerFull form-row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("h3", [_vm._v("Informações do Orçamento")]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Customizada:")]),
              _vm._v(" " + _vm._s(_vm.budget.custom ? "Sim" : "Não"))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Data/Hora:")]),
              _vm._v(" " + _vm._s(_vm.formatDate(_vm.budget.created_at)))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Cliente:")]),
              _vm._v(" " + _vm._s(_vm.budget.username.toUpperCase()))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Empresa:")]),
              _vm._v(" " + _vm._s(_vm.budget.company || "Não informado.") + " ")
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Serviço:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.budget.service.name) +
                  " " +
                  _vm._s(_vm.budget.amount) +
                  " " +
                  _vm._s(
                    _vm.transliterateServiceMetric(_vm.budget.service.metric)
                  )
              )
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Origem:")]),
              _vm._v(" " + _vm._s(_vm.budget.howDidMeetUs))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Finalidade:")]),
              _vm._v(" " + _vm._s(_vm.budget.finality.name))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Idioma:")]),
              _vm._v(" " + _vm._s(_vm.budget.language.name))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Telefone:")]),
              _vm._v(" " + _vm._s(_vm.budget.phone))
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v("Observação:")]),
              _vm._v(" " + _vm._s(_vm.budget.observation || "Sem observação."))
            ])
          ]),
          _vm._v(" "),
          !_vm.budget.custom
            ? _c(
                "div",
                {
                  staticClass:
                    "resultOrcamento desktop hidden-xs hidden-sm col-md-8"
                },
                [
                  _c("h3", [_vm._v("Propostas")]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-2 tbHeader" }, [
                      _c("div", { staticClass: "menuInfo" }, [
                        _c("div", { staticClass: "tempoAudio" }, [
                          _c("p", { staticClass: "budget-service-name" }, [
                            _vm._v(_vm._s(_vm.budget.service.name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "budget-amount" }, [
                            _vm._v(
                              _vm._s(_vm.budget.amount) +
                                " " +
                                _vm._s(
                                  _vm.transliterateServiceMetric(
                                    _vm.budget.service.metric
                                  )
                                )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "titulos" }, [
                          _c("h3", { staticStyle: { height: "43px" } }, [
                            _vm._v("Parcelado")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "budget-max-installment" }, [
                            _vm._v(
                              _vm._s(
                                _vm.maxInstallment(_vm.budget.maxInstallment)
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(1)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-10 tbBody" }, [
                      _c(
                        "div",
                        { staticClass: "row proposals-table" },
                        _vm._l(_vm.budget.proposals, function(proposal, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "col-md-3" },
                            [
                              _c(
                                "form",
                                {
                                  staticClass:
                                    "areaProposta removeBottomLeftRadius",
                                  attrs: { id: proposal.plan }
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      style: {
                                        "background-color": _vm.getPlanColor(
                                          proposal.plan
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(proposal.plan.toUpperCase())
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "titulo" }, [
                                    _c(
                                      "p",
                                      { staticStyle: { "border-top": "none" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(proposal.cashPirce)
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "titulo",
                                      staticStyle: { height: "79px" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(
                                              proposal.installmentPrice
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "titulo" }, [
                                    _c("p", [_vm._v(_vm._s(proposal.deadline))])
                                  ]),
                                  _vm._v(" "),
                                  _c("div")
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titulos" }, [
      _c("h3", [_vm._v("À vista")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titulos" }, [
      _c("h3", { staticStyle: { height: "50px" } }, [_vm._v("Prazo")]),
      _vm._v(" "),
      _c("p", [_vm._v("dias úteis")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2febbde3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2febbde3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Budgets/BudgetViewer.vue
// module id = null
// module chunks = 